import React, { useState, useEffect } from 'react';
import supabase from '../helper/supabaseClient';
import { useNavigate, Outlet } from 'react-router-dom';
import Header from '../Header';
import Navigation from './Navigation';
import MobileNavigation from './mobile/MobileNavigation';
import { useUserProfile } from '../helper/UserProfile';

function Dashboard() {
  const navigate = useNavigate();
  const { profile, loading } = useUserProfile();
  const [member, setMember] = useState("");
  
  const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    navigate("/");

  };

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) {
        navigate('/'); // React Router navigation
      } else {
      }
    });
  }, []);

  useEffect(() => {
    if (profile && profile.revalidation_membership !== undefined) {
        setMember(profile.revalidation_membership);
      }
    }, [profile]);

  if (loading || !profile) {
    return <div></div>;
  }

  return (
    <div>
      <div className="header">
        <Header />
      </div>
      <div className="dashboard-main">
        <div className="dashboard-nav">
          <Navigation />
        </div>
        <div className="dashboard-right">
          <Outlet />
        </div>

        <div className="mobile-nav">
          <MobileNavigation />
        </div>
      </div>
    </div>
  )
}

export default Dashboard